import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicAPIServices from '../../services/publicAPIServices';

const initialState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  message: ''
};

export const fetchApartmanDataBySlug = createAsyncThunk('apartmansData/fetchBySlug', async (fetchURL, thunkAPI) => {
  try {
    return await publicAPIServices.fetchDataBySlug(fetchURL);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const apartmanOtherDataSlice = createSlice({
  name: 'apartmansData',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApartmanDataBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchApartmanDataBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchApartmanDataBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.data = null;
      });
  }
});

export const { reset } = apartmanOtherDataSlice.actions;
export default apartmanOtherDataSlice.reducer;
